var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0962 17.9608C11.3884 17.9865 11.6896 18 12 18C16.9091 18 21 12 21 12C21 12 20.3306 11.0181 19.2083 9.84875L11.0962 17.9608Z",
    fill: "#C1C7D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5051 6.49485C13.7076 6.18695 12.8665 6 12 6C5.45455 6 3 12 3 12C3 12 3.75006 13.8335 5.52661 15.4734L9 12C9 10.3431 10.3431 9 12 9L14.5051 6.49485Z",
    fill: "#C1C7D0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 5.1001,
    y: 18.4346,
    width: 19,
    height: 2,
    transform: "rotate(-45 5.1001 18.4346)",
    fill: "#C1C7D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHidden);
export default __webpack_public_path__ + "static/media/eye-hidden.2c3bc195ffb0db848befd0788366ae72.svg";
export { ForwardRef as ReactComponent };